module.exports = __webpack_public_path__ + "img/step1.d5ba4d38.png";